import { connect } from 'react-redux';
import UserTable from './UserTableOKTA';
import {
  fetchPermissionsForUser,
  getGlobalCustomerMembers,
  setGlobalCustomerData,
  setTargetUser,
  setUserAffiliateTable,
  setUserTableChange,
} from '../securitySlice';

const mapStateToProps = state => ({
  affiliates: state.security.affiliates,
  globalCustomerData: state.security.globalCustomerData,
  targetUser: state.security.targetUser,
  userAffiliateTable: state.security.userAffiliateTable,
  userTableChange: state.security.userTableChange,
  users: state.security.users,
});

const mapDispatch = {
  fetchPermissionsForUser,
  getGlobalCustomerMembers,
  setGlobalCustomerData,
  setTargetUser,
  setUserAffiliateTable,
  setUserTableChange,
};

export default connect(mapStateToProps, mapDispatch)(UserTable);
